<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Fakülte Düzenle <small>( {{ name }} )</small></h3>
            </div>
            <div class="row">

               <div class="col-md-6">
                <div class="form-group">
                  <label for="university">Üniversite</label>
                  <select class="form-control custom-input" v-model="university">
                    <option v-for="university in universities" :key="university.id" :value="university.id" >{{ university.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Fakülte Adı</label>
                  <input
                    type="text"
                    v-model="name"
                    class="form-control custom-input"
                  >
                </div>
              </div>


              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                id: this.$route.params.id,
                name: '',
                university: '',
                universities: [],
                api: 'faculties/',

            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                this.$Progress.start()
                this.axios.get(this.api + this.id + '/edit').then(response => {
                    this.name = response.data.faculty.name
                    this.university = response.data.faculty.university_id
                    this.universities = response.data.universities
                    this.$Progress.finish()
                })
            },
            updateData() {
                this.$Progress.start()
                this.axios.put(this.api + this.id, {
                    university: this.university,
                    name: this.name,
                  // eslint-disable-next-line no-unused-vars
                }).then(response => {
                    // console.log(response)
                    this.$Progress.finish()
                })
            }
        },
    }
</script>

<style scoped>

</style>
